import script from "./PDFSealPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./PDFSealPop.vue?vue&type=script&setup=true&lang=ts"

import "./PDFSealPop.vue?vue&type=style&index=0&id=a8d16898&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8d16898"]])

export default __exports__